<template>
  <div class="html-container">
    <codemirror
      v-model="htmlData"
      :extensions="extensions"
      :editable="false" 
    />
  </div>
</template>

<script>
import { Codemirror } from 'vue-codemirror';
import { html } from "@codemirror/lang-html";
import { EditorView } from '@codemirror/view';
import { mapState } from 'vuex';
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';

export default {
  name: 'Template',
  components: {
    Codemirror,
  },
  data() {
    return {
      htmlData: '', // Hier wird das generierte HTML gespeichert
    };
  },
  computed: {
    ...mapState(['emailData']),
    extensions() {
      // Konfiguration für das HTML Syntax-Highlighting
      return [
        html(), 
        EditorView.lineWrapping,  
        EditorView.editable.of(false),
     ];
    },
    
  },
  mounted() {
    // Konvertiere die JSON-Daten zu HTML und speichere sie
    this.htmlData = convertJsonToHtml(this.emailData, false);
  }
}
</script>

<style scoped>
.html-container {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  text-align: left;
  background: white;
}
</style>
 